<template>
  <div class="container-edit">
    <!-- <p class="page-title">{{`${$route.params.id !== '0' ? '编辑' : '新建'}篮筐推车架`}}</p> -->
    <p class="page-title">{{`${$route.params.id === '0' ? `新建` : `编辑`}装载用具`}}</p>
    <el-button class="pull-right" type="primary" plain size="mini" @click.prevent="back()"><i class="el-icon-back"></i>返回</el-button>
    <div class="page-card">
      <el-tabs v-model="activeTab">
        <!-- 基本信息 -->
        <el-tab-pane name="basic" :label="`基本信息`">
          <div class="page-section">
            <el-form :model="info" :rules="rules" ref="info" label-width="120px" :inline="true" class="demo-form-inline">
              <!-- 品牌 -->
              <el-form-item :label="`品牌`" prop="brand">
                <el-input :placeholder="`请输入`" class="input200" v-model="info.brand"></el-input>
              </el-form-item>
              <!-- 容器名 -->
              <el-form-item :label="`名称`" prop="name">
                <el-input :placeholder="`请输入`" class="input200" v-model="info.name"></el-input>
              </el-form-item>
              <!-- 容器类型 -->
              <el-form-item :label="`类型`" prop="group">
                <el-select class="input200" v-model="info.group" :placeholder="`请选择`" @change="changeGroup()">
                  <el-option
                    v-for="item in groups"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="groups.filter(i => i.value === info.group)[0]" :label="groups.filter(i => i.value === info.group)[0]['name'] + ':'" prop="type">
                <el-input v-if="info.group === 13" class="input200" v-model="info.type"></el-input>
                <el-select v-else class="input200" v-model="info.type" :placeholder="`请选择`">
                  <el-option
                    v-for="item in types"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 所属库房 -->
              <el-form-item v-if="info.group === 13" :label="`所属库房`" prop="group">
                <el-select class="input200" v-model="info.warehouse_id" :placeholder="`请选择`">
                  <el-option
                    v-for="item in houses"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 节点类型 -->
              <el-form-item :label="`流程节点`" prop="node_type">
                <el-select class="input200" v-model="info.node_type" :placeholder="`请选择`" clearable>
                  <el-option
                    v-for="item in nodes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 规格型号 -->
              <el-form-item :label="`规格型号`" prop="">
                <el-input :placeholder="`请输入`" class="input200" v-model="info.specification"></el-input>
              </el-form-item>
              <!-- 详情描述 -->
              <el-form-item :label="`描述`" prop="">
                <el-input :placeholder="`请输入`" class="input500" v-model="info.description" :rows="2" type="textarea"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <!-- 编码管理 -->
        <el-tab-pane name="code" :label="`编码`">
          <div class="add-line">
            <!-- 请填写备注 -->
            <el-input class="input200" v-model="addInfo.remark" :placeholder="`备注`"></el-input>
            <el-input-number class="input200 mt10 p12" v-model="addInfo.number" :min="1" label="描述文字"></el-input-number>
            <!-- 添加 -->
						<el-button class="mt10" size="mini" type="primary" @click.prevent="addCode()"><i class="el-icon-plus"></i> 添加</el-button>
            <!-- 批量打印 -->
            <el-button class="mt10" size="mini" type="primary" @click="printTag(tableSelection)">批量打印</el-button>
          </div>
          <el-table
            style="margin-top: 10px;"
            :data="codeList"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            border
          >
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              v-for="(item) in codeHeaders"
              :key="item.id"
              :type="item.type"
              :label="item.label"
              :prop="item.prop"
              :sortable="!!item.sortKey ? 'custom': false"
              :sort-by="item.sortKey"
              :width="item.width">
                <template slot-scope="scope">
                  <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
                  <img v-else-if="item.prop === 'qrcode'" :src="`${$utils.generateCode(scope.row.code)}`" alt="" style="height: 60px;width: auto;">
                  <span v-else>{{scope.row[item.prop]}}</span>
                  <!-- 清洗机绑定 -->
                  <el-tooltip v-if="item.handle && info.group == 2" effect="dark" :content="`绑定`" placement="top-start">
                    <el-button class="p0 fontsize20" type="text" @click.prevent="openEquipment(scope.row)"><i class="el-icon-set-up"></i></el-button>
                  </el-tooltip>
                  <!-- 清洗机解绑 -->
                  <el-tooltip v-if="item.handle && info.group == 2" effect="dark" :content="`解绑`" placement="top-start">
                    <el-button class="p0 fontsize20" type="text" @click.prevent="removeEquipmentId(scope.row)"><i class="el-icon-turn-off"></i></el-button>
                  </el-tooltip>
                  <!-- 打印 -->
                  <el-tooltip v-if="item.handle" effect="dark" :content="`打印`" placement="top-start">
                    <el-button class="p0 fontsize20" type="text" @click.prevent="printTag([scope.row])"><i class="el-icon-printer"></i></el-button>
                  </el-tooltip>
                  <!-- 删除 -->
                  <el-tooltip v-if="item.handle" effect="dark" :content="`删除`" placement="top-start">
                    <el-button class="p0 fontsize20" type="text" @click.prevent="deleteCode(scope.row.id)"><i class="el-icon-delete"></i></el-button>
                  </el-tooltip>
                </template>
            </el-table-column>
          </el-table>
          <pagination :queryParams="codeQueryParams" :getList="getCodeList" />
        </el-tab-pane>
        <el-tab-pane name="file" :label="`附件`">
            <el-button @click="openUpload()" size="mini" type="primary"><i class="el-icon-upload2">上传</i></el-button>
            <div class="mt10">
              <el-table
                stripe
                border
                :data="fileList"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="#"
                  align="center"
                  width="60">
              </el-table-column>
                <el-table-column
                  prop="name"
                  :label="`文件名`"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop=""
                  :label="`类型`"
                  align="center">
                  <template slot-scope="scope">
                      {{fileTypes.filter(i => i.value === scope.row.type)[0].name}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop=""
                  align="center"
                  :label="`操作`">
                  <template slot-scope="scope">
                    <el-button class="p0 fontsize20" type="text" @click.prevent="download(scope.row.url)"><i class="el-icon-download"></i></el-button>
                    <el-button class="p0 fontsize20" type="text" @click.prevent="deleteFile(scope.$index)"><i class="el-icon-delete"></i></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </el-tab-pane>
      </el-tabs>
      <div class="mt10">
        <el-button size="small" type="primary" @click="save()">保存</el-button>
        <el-button size="small" @click="back()">取消</el-button>
      </div>
    </div>
    <UploadFile ref="uploadFile" @complete="getFile" />
    <!-- 设备选择 -->
    <equipment-select ref="EquipmentSelect" :type="1" @confirm="getEquipmentChange" />
  </div>
</template>

<script>
import { containerEdit, containerCode, containerFile, containerList, deleteCode, addCode, allWarehouse, containerCodeEdit } from '@/api.js'
import UploadFile from '@/components/common/UploadFile.vue'
import Pagination from '@/components/common/Pagination.vue'
import { pageSize } from '@/utils/Config.js'
import EquipmentSelect from '@/components/machine/equipments/Select.vue'
export default {
  name: 'ContainerEdit',
  components: {
    UploadFile,
    Pagination,
    EquipmentSelect
  },
  watch: {
    activeTab(newValue) {
      if (newValue === 'code' && !this.pageId) {
        // 请先保存基本信息
        this.$message(`请先保存基本信息`)
        
        this.$nextTick(() => {
          this.activeTab = 'basic'
        })
      }
    }
  },
  data() {
    return {
      activeTab: 'basic',
      pageId: 0,
      info: {},
      rules: {
        name: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, cb) => {
              if (!value || value && !value.trim()) {
                cb(`名称不能为空`)
              } else {
                cb()
              }
            }
          }
        ],
        group: [
        // 请选择容器类型
          { required: true, message: '请选择容器类型', trigger: ['blur'] }
        ],
        // type: [
        // // 请选择类型
        //   { required: true, message: '请选择类型', trigger: ['blur'] }
        // ]
      },
      addInfo: {
        remark: '',
        start_date: '',
        number: 0
      },
      types: [],
      houses: [],
      nodes: [
        {
          name: `回收`,
          id: 1
        },
        {
          name: `发放`,
          id: 2
        },
        {
          name: `清洗`,
          id: 3
        },
        {
          name: `灭菌`,
          id: 4
        }
      ],
      groups: [],
      codeQueryParams: {
        pageIndex: 1,
        pageSize,
        _total: 0
      },
      codeHeaders: [],
      codeList: [],
      fileList: [],
      fileTypes: [],
      tableSelection: [],
      handleCodeItem: null
    }
  },
  async mounted() {
    const {id} = this.$route.params
    this.pageId = Number(id)
    await this.getTypes()
    await this.getWareHouses()
    if (this.pageId) {
      this.getDetail()
      this.getCodeList()
      this.getFileList()
    }
  },
  methods: {
    getWareHouses() {
      return this.$request('get', allWarehouse, {})
      .then(res => {
        if (res) {
          this.houses = res
        }
      })
    },
    getTypes() {
      // 获取容器类型
      return this.$utils.getDict([304, 347])
      .then((options) => {
        if ( options ) {
          this.fileTypes = options[347]
          this.groups = options[304]

          if (!this.pageId) {
            this.info.group = this.groups[0].value
            this.changeGroup()
            this.info.type = this.types[0]? this.types[0].value : undefined
          }
        }
      })
    },
    async getDetail() {
      // 获取详情
      const url = containerEdit.replace('{id}', this.pageId)
      const res = await this.$request('get', url, {})
      if (res) {
        res.node_type = res.node_type || undefined
        this.info = res
        this.types = this.groups.filter(i => i.value === this.info.group)[0]['son']
      }
    },
    changeGroup() {
      // 容器类型变化
      this.types = this.groups.filter(i => i.value === this.info.group)[0]['son']
      this.$set(this.info, 'type', this.types[0] ? this.types[0].value : undefined)
    },
    back() {
      this.$router.back()
    },
    async getCodeList() {
      // 获取编码列表
      const { pageId } = this
      const url = containerCode.replace('{id}', pageId)
      const {
        pageIndex,
        pageSize,
        orderBy,
        order
      } = this.codeQueryParams
      const queryParams = {
        page: pageIndex,
        per_page: pageSize,
        order_column: orderBy,
        order
      }
      
      const res = await this.$request('get', url, queryParams)
      if (res) {
        const prev = [
          {
            width: 60,
            label: '#',
            prop: '',
            type: 'index',
            checked: true
          }
        ]
        const last = [
          {
            width: 'auto',
            label: `操作`,
            prop: '',
            checked: true,
            handle: true
          }
        ]

        this.codeList = res.data
        this.codeQueryParams._total = res.total
        this.codeHeaders = this.codeHeaders.length > 0 ? this.codeHeaders : this.$utils.generateColumns(res.columns, prev, last)
      }
    },
    async getFileList() {
      // 获取编码列表
      const { pageId } = this
      const url = containerFile.replace('{id}', pageId)
      const res = await this.$request('get', url, {})
      if (res) {
        this.fileList = res
      }
    },
    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.codeQueryParams.order = orderString
      this.codeQueryParams.orderBy = orderBy
      this.getCodeList()
    },
    async addCode() {
      // 添加编码
      const { remark, number } = this.addInfo
      const item = {
        remark, number
      }
      const url = addCode.replace('{id}', this.pageId)
      const res = await this.$request('post', url, item)
      if (res) {
        //新增成功
        this.$message.success(`新增成功`)
        this.getCodeList()
      }
    },
    async deleteCode(id) {
      // 删除编码
      const url = deleteCode.replace('{id}', id)
      const res = await this.$request('post', url, {})
      if (res) {
        // this.$message.success('删除成功')
        this.$message.success(`删除成功`)

        this.getCodeList()
      }
    },
    openUpload() {
      this.$refs.uploadFile.show(this.fileTypes)
    },
    getFile(file) {
      // 上传文件
      const item = {
        name: file.name,
        url: file.fileUrl,
        id: file.fileId,
        type: file.type
      }

      this.fileList.push(item)
    },
    deleteFile(index) {
      // 删除文件
      this.fileList.splice(index, 1)
    },
    save() {
      // 保存，提交
      this.$refs.info.validate(valid => {
        if (!valid) {
          // this.$message.error('请完善必填信息')
          this.$message.error(`请填写必填项`)
          this.activeTab = 'basic'
          return
        } else {
          const { pageId } = this
          const { name, brand, group, type, specification, description, warehouse_id, node_type } = this.info
          const file_id = this.fileList.map(i => i.id)
          // const codes = this.codeList.map(i => { if (i.id) { return {id: i.id, code: i.code, remark: i.remark} } else { return { remark: i.remark }}  })
          const info = {
            name, brand, group, type, spec: specification, description, file_id, warehouse_id, node_type
          }
          const url = pageId ? containerEdit.replace('{id}', pageId) : containerList
          this.$request('post', url, info)
          .then((res) => {
            if (res) {
              // this.$message.success('保存成功')
              this.$message.success(`保存成功`)
              if (pageId) {
                this.getDetail()
              } else {
                this.$router.replace(`/basic/container/edit/${res.id}`)
                this.pageId = Number(res.id)
              }
              // this.back()
            }
          })
        }
      })

    },
    printTag(row) {
      const data = row.map((item) => {
        item.qrcode = this.$utils.generateCode(item.code)
        item.barcode = this.$utils.generateCode(item.code ,'code128')
        
        return item
      })

      const type = 'basketry'
      
      this.$utils.print({data, type}, 'encode')
    },
    openEquipment(item) {
      // 打开设备选择（清洗机）
      const { equipment_id } = item
      const { EquipmentSelect } = this.$refs
      this.handleCodeItem = item

      EquipmentSelect && EquipmentSelect.open(equipment_id)
    },
    getEquipmentChange(equipment_id) {
      const { id } = this.handleCodeItem
      const url = containerCodeEdit.replace('{id}', id)
      const params = {
        equipment_id
      }
      this.$request('post', url, params)
      .then(res => {
        if (res) {
          this.$message.success(`操作成功`)

          this.getCodeList()
        }
      })
    },
    removeEquipmentId(item) {
      this.handleCodeItem = item

      this.getEquipmentChange(0)
    },
    handleSelectionChange(val) {
      this.tableSelection = val
    },
    download(url) {
      // 预览文件
      window.open(url, '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
  .container-edit {
    position: relative;
    .add-line {
      div {
        margin-right: 10px;
      }
    }
  }
</style>